import _ from 'lodash';
import { combineReducers } from 'redux';

import { modalMessage } from '../../components/common/modal-message/modal-message.reducer';
import { oldMediaAssets } from '../../components/media-assets/redux/old-media-assets.reducer';
import { applicationPermission } from '../../features/applications/application-overview/application-permission-card/application-permission-card.reducer';
import { applicationWebhooks } from '../../features/applications/application-overview/application-webhooks/application-webhooks.reducer';
import { applicationsUi } from '../../features/applications/applications-preview-list/applications.reducer';
import { imageFeatures } from '../../features/file-manager/file-info/image-info/image-features/image-features.reducer';
import { fileManager } from '../../features/file-manager/redux/file-manager.reducer';
import { flows } from '../../features/flows/redux/flows.reducer';
import { accordion } from '../../features/operation-panel/accordion/accordion.reducer';
import { operationPanel } from '../../features/operation-panel/operation-panel.reducer';
import { projectOverviewState } from '../../features/project-overview/project-overview.reducer';
import { replications } from '../../features/replications/redux/replications.reducer';
import { sidebar } from '../../features/sidebar/sidebar.reducer';
import { team } from '../../features/team/team.reducer';
import { router } from '../../router/router.reducer';
import { fileManagerComponent } from '../file-manager-component/file-manager-component.reducer';
import {
  defaultFileManagerState,
  FILE_MANAGER_PAGE_COMPONENT_ID,
  FileManagerComponentState,
  SingleFileManagerComponentState,
} from '../file-manager-component/file-manager-component.types';
import { filesRootReducer } from '../files/files-root.reducer';
import { jobs } from '../jobs/jobs.reducer';
import { permissions as permissionsNew } from '../permissions/permissions.reducer';
import { projects } from '../projects/projects.reducer';
import { Action } from '../redux.types';
import { sortedColumns } from '../sorted-columns/sorted-columns.reducer';
import { allApplications } from './all-applications/all-applications';
import { applications } from './application/applications';
import { liveStreamAnalytics } from './live-streams/live-stream-analytics.reducer';
import { liveStreams } from './live-streams/live-streams.reducer';
import { notifications } from './notifications';
import { organization } from './organization';
import { requestsCounter } from './requests-counter';
import { session } from './session/session';
import { StoreState, StoreStateNonDependable } from './store.types';
import { jobsList } from '../jobs-list/jobs-list.reducer';

const rootReducerNonDependable = combineReducers<StoreStateNonDependable>({
  allApplications,
  applications,
  liveStreams,
  liveStreamAnalytics,
  filesRoot: filesRootReducer,
  fileManagerComponent,
  oldMediaAssets,
  notifications,
  organization,
  projects,
  requestsCounter,
  session,
  router,
  replications,
  team,
  modalMessage,
  sidebar,
  operationPanel,
  accordion,
  imageFeatures,
  jobs,
  applicationsUi,
  applicationWebhooks,
  applicationPermission,
  permissionsNew,
  flows,
  projectOverviewState,
  columnsSorting: sortedColumns,
  jobsList,
});

const getFileManagerPageComponentOrDefault = (
  state: FileManagerComponentState,
): SingleFileManagerComponentState =>
  state[FILE_MANAGER_PAGE_COMPONENT_ID] || defaultFileManagerState;

export const rootReducer = (state: StoreState, action: Action): StoreState => {
  const nonDependableState: StoreStateNonDependable = rootReducerNonDependable(
    _.omit(state, ['fileManagerPage']) as StoreStateNonDependable,
    action,
  );

  const fileManagerPageComponent = getFileManagerPageComponentOrDefault(
    nonDependableState.fileManagerComponent,
  );

  return {
    ...nonDependableState,
    fileManagerPage: fileManager(
      state && state.fileManagerPage,
      action,
      fileManagerPageComponent,
    ),
  };
};
